// extracted by mini-css-extract-plugin
module.exports = {"skip_link":"SkipContent_skip_link__kuVZk"};